import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const getMonitoringStatus = async () => {
  const { data } = await SigliveServiceSSE({
    method: 'GET',
    url: `/monitoring-operator/status`,
  });

  return data?.data;
};

export default getMonitoringStatus;
